function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Support = function Support(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 30 30",
    a11yTitle: "Support"
  }, props), React.createElement("style", {
    type: "text/css"
  }), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M8,25.4c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.8-0.7-0.8-1.2v-2.9H6.5c-1.9,0-3.5-1.6-3.5-3.5V8.1c0-1.9,1.6-3.5,3.5-3.5h17.1 c1.9,0,3.5,1.6,3.5,3.5v9.6c0,1.9-1.6,3.5-3.5,3.5H12.6L8.9,25C8.6,25.3,8.3,25.4,8,25.4z M6.5,5.7c-1.3,0-2.4,1.1-2.4,2.4v9.6 c0,1.3,1.1,2.4,2.4,2.4h0.7c0.3,0,0.6,0.2,0.6,0.6v3.4c0,0.1,0.1,0.2,0.1,0.2c0,0,0.1,0,0.2,0l3.9-3.9c0.1-0.1,0.2-0.2,0.4-0.2 h11.1c1.3,0,2.4-1.1,2.4-2.4V8.1c0-1.3-1.1-2.4-2.4-2.4H6.5z"
  })), React.createElement("g", null, React.createElement("rect", {
    x: "14.8",
    y: "16.3",
    width: "1.1",
    height: "1.5"
  })), React.createElement("g", null, React.createElement("path", {
    d: "M16,15.5h-1.1c0-1.2,0.2-2,1.3-2.9c0.4-0.4,0.9-1,0.9-1.6c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.7-0.5-1.2-0.5c0,0,0,0,0,0 c-1,0-1.6,0.6-1.6,1.6h-1.1c0-1.6,1.1-2.7,2.7-2.7h0c0.8,0,1.5,0.3,2,0.8c0.5,0.5,0.8,1.2,0.8,2c0,1-0.7,2-1.3,2.5 C16.1,14.1,16,14.5,16,15.5z"
  }))));
};